import administrativeModule from './administrativeModule'
import financialModule from './financialModule'
import attendanceModule from './attendanceModule'
import protocolModule from './protocolModule'
import convenioModule from './convenioModule'
import ordemSercicoModule from './ordemServicoModule'
import eventModule from './eventModule'

export default [
  ...administrativeModule,
  ...financialModule,
  ...attendanceModule,
  ...protocolModule,
  ...convenioModule,
  ...ordemSercicoModule,
  ...eventModule,
  {
    path: '/modules/administrative/phisicalPerson/editAssociante/:id',
    name: 'editAssociante',
    component: () => import(
      '@/views/modules/administrative/phisicalPerson/form/FormPrincipalAssociante.vue'
    ),
    meta: {
      pageTitle: 'Editando Associado',
      action: 'ROLE_ASSOCIADO_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Administrativo | Editando Associado',
        },
      ],
    },
  },
  {
    path: '/modules/administrative/phisicalPerson/editAggregate/:id',
    name: 'editAggregate',
    component: () => import(
      '@/views/modules/administrative/phisicalPerson/form/FormPrincipalAggregate.vue'
    ),
    meta: {
      pageTitle: 'Editando Agregados',
      action: 'ROLE_AGREGADO_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Administrativo | Editando Agregados',
        },
      ],
    },
  },
  {
    path: '/modules/administrative/phisicalPerson/editDependent/:id',
    name: 'editDependent',
    component: () => import(
      '@/views/modules/administrative/phisicalPerson/form/FormPrincipalDependente.vue'
    ),
    meta: {
      pageTitle: 'Editando Dependentes',
      action: 'ROLE_DEPENDENTE_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Administrativo | Editando Dependentes',
        },
      ],
    },
  },
  {
    path: '/modules/administrative/phisicalPerson/editEmployee/:id',
    name: 'editEmployee',
    component: () => import(
      '@/views/modules/administrative/phisicalPerson/form/FormPrincipalEmployee.vue'
    ),
    meta: {
      pageTitle: 'Editando Funcionário',
      action: 'ROLE_FUNCIONARIO_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Administrativo | Editando Funcionário',
        },
      ],
    },
  },
  {
    path: '/modules/administrative/phisicalPerson/editOther/:id',
    name: 'editOther',
    component: () => import(
      '@/views/modules/administrative/phisicalPerson/form/FormPrincipalOther.vue'
    ),
    meta: {
      pageTitle: 'Editando Outro',
      action: 'ROLE_OUTRO_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Administrativo | Editando Outro',
        },
      ],
    },
  },
  {
    path: '/modules/administrative/juridicPerson/editFornecedor/:id',
    name: 'editFornecedor',
    component: () => import(
      '@/views/modules/administrative/juridicPerson/fornecedor/FormPrincipalEditarFornecedor.vue'
    ),
    meta: {
      pageTitle: 'Editando Fornecedor',
      action: 'ROLE_FORNECEDOR_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Administrativo | Editando Fornecedor',
        },
      ],
    },
  },
  {
    path: '/modules/attendance/attendance/editAtendimento/:id',
    name: 'editAtendimento',
    component: () => import(
      '@/views/modules/attendance/attendance/form/AttendanceEditForm.vue'
    ),
    meta: {
      pageTitle: 'Editando Atendimento',
      action: 'ROLE_ATEND_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Atendimento | Editando Atendimento',
        },
      ],
    },
  },
  {
    path: '/modules/convenios/edit/:id',
    name: 'editConvenio',
    component: () => import('@/views/modules/convenio/form/FormConvenio.vue'),
    meta: {
      pageTitle: 'Editando Convênio',
      action: 'ROLE_CONV_CONSULTAR',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Convênio | Editando Convênio',
        },
      ],
    },
  },
  {
    path: '/modules/Attendance/attendance/AttendanceProfissional/editAtendimentoProfissional/:id',
    name: 'editAtendimentoProfissional',
    component: () => import('@/views/modules/profissional/form/ProfissionalForm.vue'),
    meta: {
      pageTitle: 'Editando Atendimento',
      action: 'ROLE_PROFISSIONAL',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Atendimento | Editando Atendimento',
        },
      ],
    },
  },
  {
    path: '/modules/Attendance/attendance/AttendanceProfissional/editAtendimentoLegadoProfissional/:id',
    name: 'editAtendimentoLegadoProfissional',
    component: () => import(
      '@/views/modules/profissional/atendimentoLegado/AtendimentoLegadoEditForm.vue'
    ),
    meta: {
      pageTitle: 'Editando Atendimento Legado',
      action: 'ROLE_PROFISSIONAL',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Atendimento | Editando Atendimento Legado',
        },
      ],
    },
  },
  {
    path: '/modules/event/event/editEvent/:id',
    name: 'editEvent',
    component: () => import('@/views/modules/event/form/EventForm.vue'),
    meta: {
      pageTitle: 'Editando Evento',
      action: 'ROLE_EVENTO',
      resource: 'ACL',
      breadcrumb: [
        {
          text: 'Modulo Evento | Editando Evento',
        },
      ],
    },
  },
]
